// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"MjrXYJt3","groupItem":"__7UG6ljrm","itemTitle":"bFYkVUME","links":"q_PjcXco","link":"qwP_VZuB"};